module.exports = __webpack_public_path__ + "static/media/advertencia5.23476284.PNG";